<template>
  <div class="container">
    <el-carousel
      class="carousel"
      height="100%"
      arrow="never"
      trigger="click"
      :autoplay="false"
      ref="carousel"
    >
      <el-carousel-item v-for="image in coverImages" :key="image">
        <img class="cover-image" :src="image"/>
      </el-carousel-item>
    </el-carousel>

    <div class="cover-image-gradient"></div>
    <div class="link-container">
      <router-link class="link" to="/gallery">Gallery</router-link>
      <router-link class="link" to="/about">About</router-link>
      <router-link class="link" to="/buy">Buy</router-link>
    </div>
  </div>
</template>
<script>
  import { Carousel, CarouselItem } from 'element-ui';
  import { metaDescriptions, metaImage } from '@/utils/meta';

  let interval;

  export default {
    name: 'landing',
    bodyClass: 'landing-page',
    components: {
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
    },
    mounted() {
      interval = setInterval(this.nextSlide, 4000);
    },
    methods: {
      nextSlide() {
        this.$refs.carousel.next();
      },
    },
    beforeDestroy() {
      if (interval) {
        clearInterval(interval);
      }
    },
    metaInfo: {
      title: 'mathiasmoeller.com | Nature & Travel Photography',
      meta: [
        ...metaDescriptions('I am a hobby photographer and I love to shoot landscapes, cultures and their people. '
          + 'Feel free to contact me regarding image acquisition or assignments or if you just want to say hi!'),
        ...metaImage('/img/galleries/thumbs/wildlife/PB203016rm-small.jpg'),
      ],
    },
    data() {
      return {
        coverImages: [
          '/img/main.jpg',
          '/img/galleries/large/drone/DJI_0657.jpg',
          '/img/galleries/large/wildlife/PB203016rm.jpg',
          '/img/galleries/large/traveling/P3123584.jpg',
          '/img/galleries/large/people/P6190643.jpg',
          '/img/galleries/large/nature/P3281027.jpg',
          '/img/galleries/large/mountains/P4110766.jpg',
          '/img/galleries/large/architecture/architecture.jpg',
        ],
      };
    },
  };
</script>
<style lang="scss" scoped>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .carousel {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  .cover-image {
    width: 100%;
    object-fit: cover;
    height: 100%;
  }

  .cover-image-gradient {
    position: absolute;
    top: 0;
    background-color: black;
    opacity: 0.3;
    width: 100%;
    height: 100%;
    z-index: 2;
    pointer-events: none
  }

  .link-container {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;

    @media (max-width: 576px) {
      flex-direction: column;
    }
  }

  .link {
    color: white;
    font-size: 18px;
    padding: 4px 30px;
    text-transform: uppercase;

    &:not(:last-child) {
      border-right: solid white 1px
    }

    @media (max-width: 576px) {
      flex-direction: column;
      padding: 18px 30px;
      width: 170px;
      text-align: center;

      &:not(:last-child) {
        border-right: 0;
        border-bottom: solid white 1px;
      }
    }
  }

</style>
